import { parsePhoneNumberWithError, CountryCode } from 'libphonenumber-js';

export const splitPhoneNumberAndCountryCode = (number, countryCodes) => {
  //+ is inlcuded in number
  const oneDigitCountryCode = number.slice(0, 2);
  const twoDigitCountryCode = number.slice(0, 3);
  const threeDigitCountryCode = number.slice(0, 4);
  const fourDigitCountryCode = number.slice(0, 5);

  const codes = [
    {
      code: fourDigitCountryCode,
      sliceNumber: 5,
    },
    {
      code: threeDigitCountryCode,
      sliceNumber: 4,
    },
    {
      code: twoDigitCountryCode,
      sliceNumber: 3,
    },
    {
      code: oneDigitCountryCode,
      sliceNumber: 2,
    },
  ];

  let result = {
    code: undefined,
    number: undefined,
  };

  codes.map((item) => {
    const isCountryCodeFound = findCountryCode(item.code, countryCodes);
    if (isCountryCodeFound) {
      const data = getObject(isCountryCodeFound, number, item.sliceNumber);
      result = {
        code: data.code,
        number: data.number,
      };
    }
  });

  return result;
};

const findCountryCode = (countryCode, countryCodes) => {
  const data = countryCodes.find((item) => item.code === countryCode);
  return data;
};

const getObject = (data, number, sliceNumber) => {
  let obj = {
    code: data?.code,
    number: number.slice(sliceNumber),
  };
  return obj;
};

export const sanitizedNumber = (number: string) => {
  return number ? number.replace(/[-() ]/g, '') : undefined;
};

export const formatPhoneNumber = (number: string) => {
  if (!number || number.length < 10) {
    return number;
  }
  if (
    number.includes('(') ||
    number.includes(')') ||
    number.includes('-') ||
    number.includes(' ') ||
    number.includes('+')
  ) {
    return number;
  }

  let firstNumber;
  let numberFirstPart;
  let numberMiddlePart;
  let numberLastPart;
  if (number.length === 11) {
    firstNumber = number.slice(0, 1);
    numberFirstPart = number.slice(1, 4);
    numberMiddlePart = number.slice(4, 7);
    numberLastPart = number.slice(7);
    return `${firstNumber} (${numberFirstPart}) ${numberMiddlePart}-${numberLastPart}`;
  } else {
    numberFirstPart = number.slice(0, 3);
    numberMiddlePart = number.slice(3, 6);
    numberLastPart = number.slice(6);
  }

  //us phone format
  return `(${numberFirstPart}) ${numberMiddlePart}-${numberLastPart}`;
};

export const parseRawPhoneNumber = (phone: string, country?: string) => {
  const code: CountryCode | undefined =
    (Object.entries(countriesAbbrMapping).find(
      ([code, name]) => name === country,
    )?.[0] as CountryCode) ?? undefined;

  try {
    return parsePhoneNumberWithError(phone, code);
  } catch (error) {
    console.error('Parse Phone Error:', error);
  }
  return null;
};

export const getPhoneFormattedText = (phone: string, country?: string) => {
  const result = parseRawPhoneNumber(phone, country);
  if (result) {
    return `+${result.countryCallingCode} ${result.formatNational()}`;
  }
  return phone;
};

export const getPhoneURI = (phone: string) => {
  const result = parseRawPhoneNumber(phone);
  if (result) {
    return result.getURI();
  }
  return phone;
};

export const countriesAbbrMapping: Record<string, string> = {
  US: 'United States',
  CA: 'Canada',
  MX: 'Mexico',
  BS: 'Bahamas',
  BZ: 'Belize',
  CR: 'Costa Rica',
  KY: 'Cayman Islands',
  SX: 'St. Martin',
  TC: 'Turks and Caicos',
  PA: 'Panama',
};
